import request from '@/api/base'

// 获取合同列表
const getContractList = (params) => {
  // params.test = true
  return request.post('/portal/contract/queryContractPageByCondition', params)
}
const queryContractPageByConditionSimple = (params) => {
  // params.test = true
  return request.post('/portal/contract/queryContractPageByConditionSimple', params)
}
// 获取合同列表
const newgetContractList = (params) => {
  // params.test = true
  if (process.env.NODE_ENV === 'development') {
    // params.mockApi = true
  }
  return request.post('/portal/contract/queryBusinessContractByCondition', params)
}
// 获取合同列表
const queryHeatingContractPageByCondition = (params) => {
  // params.test = true
  return request.post('/portal/contract/queryHeatingContractPageByCondition', params)
}
// 计算供暖费
const heatingBillCalculation = (params) => {
  // params.test = true
  return request.post('/portal/contract/heatingBillCalculation', params)
}
// 供暖费生成账单
const addBillsList = (params) => {
  return request.post('/portal/charge-bill/addBillsList', params)
}
// 获取合同详情
const getContractInfo = (params) => {
  // params.test = true
  if (process.env.NODE_ENV === 'development') {
    // params.mockApi = true
  }
  return request.get('/portal/contract/queryContractById', {params})
}

// 检查合同编号是否可用
const checkSerialNumberIsExit = (params) => {
  // params.mockApi = true
  // params.test = true
  return request.post('/portal/contract/checkContractSerialNumber', params)
}

const confirmContract = (params) => {
  return request.post('/portal/contract/confirmContract', params)
}

// 新增合同
const addContract = (params) => {
  // params.noIpark = true
  // params.test = true
  return request.post('/portal/contract/addContract', params)
}
// 新增合同
const updateContract = (params) => {
  // params.noIpark = true
  return request.post('/portal/contract/updateContract', params)
}
// 获取合同文件流 pdf/ doc
const getContractFile = (params) => {
  return request.post('/open/contract/file/getContractFile', params)
}
// 获取园区合同模板
const getParkContractModel = (params) => {
  return request.post('/portal/contract/file/getParkContractModel', params)
}

const deleteContract = (params) => {
  return request.post('/portal/contract/delContractByIds', params)
}
const delContract = (params) => {
  return request.get('/portal/contract/delContract', {params})
}
// 合同账单列表
const showBillsListbyPage = (params) => {
  return request.get('/portal/contract/showBillsListbyPage', {params})
}
// 合同账单列表
const showBillsListbyPage2 = (params) => {
  return request.get('/portal/contract/showBillsListbyPage2', {params})
}
// 费用账单 导出
const exportBillsListbyPage = (params) => {
  return request.post('/portal/contract/exportBillsListbyPage', params, { responseType: 'blob' })
}
const showThirdPartyContractBills = (params) => {
  // params.test = true
  return request.post('/portal/contract/showThirdPartyContractBills', params)
}
const NewshowThirdPartyContractBills = (params) => { // 返成合同专用生成账单
  // params.test = true
  return request.post('/portal/contract/showSharingContractBills', params)
}
const showSharingContractBillsByItem = (params) => { // 返成合同专用生成账单
  // params.test = true
  return request.post('/portal/contract/showSharingContractBillsByItem', params)
}

// 获取企业信息，提供给选择乙方使用
const getCompanyList = (params) => {
  return request.post('/portal/company/queryList', params)
}
// 查询附件列表
const fileQueryInfo = (params) => {
  if (process.env.NODE_ENV === 'development') {
    // params.mockApi = true
  }
  return request.post('/portal/contract/attachment/queryInfo', params)
}

// 删除附件
const delAttachment = (params) => {
  return request.post('/portal/contract/attachment/delAttachment', params)
}
// 添加附件

const addAttachment = (params) => {
  return request.post('/portal/contract/attachment/addAttachment', params)
}

// 获取合同模板
const getContractTerms = (params) => {
  return request.post('/portal/contract/file/getContractTerms', params)
}

const setContractTerms = (params) => {
  return request.post('/portal/contract/file/setContractTerms', params)
}

//
const getBillList = (params) => {
  return request.post('/portal/contract/showBillListByType', params)
}
// 合同归档
const archiveContract = (params) => {
  return request.post('/portal/contract/archiveContract', params)
}
// 合同变更，变更合同细腻
const modifyContract = (params) => {
  return request.post('/portal/contract/modifyContract', params)
}
// 合同变更,确定变更时间，并计算账单
const setEffectDate = (params) => {
  return request.post('/portal/contract/setModifyContractEffectDate', params)
}
// 合同变更生效
const setContractEffect = (params) => {
  return request.post('/portal/contract/setModifyContractEffect', params)
}
// 合同续签，生成草稿合同
const renewContract = (params) => {
  return request.post('/portal/contract/renewContract', params)
}
// 合同变更生效
const setRenewEffectDate = (params) => {
  return request.post('/portal/contract/setRenewContractEffect', params)
}

// 获取合同变更后的变更记录
const getContractVersionList = (params) => {
  return request.post('/portal/contract/queryModifyRecordList', params)
}
// 获取合同变更后的变更记录
const queryLastModifyRecordList = (params) => {
  return request.post('/portal/contract/queryLastModifyRecordList', params)
}
/** 新的合同退租接口 */
const newRenancyContract = (params) => {
  return request.post('/portal/contract/terminateContract', params)
}

/** ******退租相关，逻辑和合同不同 */

// 获取合同退租单列表
const getRenancyContractList = (params) => {
  // params.test = true
  return request.post('/portal/contractTerminate/queryList', params)
}
// 获取合同退租单详情
const getRenancyContractDetail = (params) => {
  // params.test = true
  return request.post('/portal/contractTerminate/queryContractPageByCondition', params)
}
// 删除合同退租单
const deleteRenancyContract = (params) => {
  return request.post('/portal/contractTerminate/updateTerminateNotShow', params)
}
// 新增合同退租单
const addRenancyContract = (params) => {
  return request.post('/portal/contractTerminate/addTerminate', params)
}
// 送审合同退租单
const auditContractTerminate = (params) => {
  return request.post('/portal/contractTerminate/auditContractTerminate', params)
}
// 需改合同退租单
const updateRenancyContract = (params) => {
  return request.post('/portal/contractTerminate/updateTerminate', params)
}
// 需改合同退租单
const getTerminateNumber = (params) => {
  return request.get('/portal/contractTerminate/getTerminateNumber', {params})
}

// 获取合同在租期中的企业列表
const getContractCompanyList = (params) => {
  return request.get('/portal/contract/queryActivateCompanyByParkId', {params})
}
// 获取合同退租业务信息详情
const queryContractBillInfo = (params) => {
  return request.get('/portal/contract/queryContractBillInfo', {params})
}
// 获取合同退租业务信息详情
const renewTerminateContractBill = (params) => {
  return request.post('/portal/contract/renewTerminateContractBill', params)
}
// 获取合同退租业务信息详情
const queryTerminateContractBillByPage = (params) => {
  return request.post('/portal/contract/queryTerminateContractBillByPage', params)
}
// 获取合同在租期中的企业列表
const getCompanyContractList = (params) => {
  return request.post('/portal/contract/queryContractInfoByCompanyIds', params)
}
// 获取对应的供暖费
const getBillStandardList = (params) => {
  return request.post('/portal/device/bill/queryBillStandardListTypeByType', params)
}
// 获取对应的供暖费
const updateCompanyCreditCode = (params) => {
  return request.post('/portal/company/updateCompanyCreditCode', params)
}
// 确定账单
const updateCount = (params) => {
  return request.post('/portal/contract/setBillsTotal', params)
}
// 确定账单
const setBillsTurnover = (params) => {
  return request.post('/portal/contract/setBillsTurnover', params)
}
const fetchChangeRecord = (params) => {
  return request.post('/portal/contract/addContractModifyRecord', params)
}
const getChangeRecordDetail = (params) => {
  return request.post('/portal/contract/queryModifyRecordByContractId', params)
}

const updateContractNumAndData = (params) => {
  return request.post('/portal/contract/updateContractNumAndData', params)
}

// 选择优惠期快捷方式计算租金
const getCalDiscount = (params) => {
  return request.post('/portal/contract/calDiscount', params)
}

// 合同续签列表
const getContractRenewList = (params) => {
  return request.post('/portal/contractRenew/queryList', params)
}
// 合同变更列表
const getContractChangeList = (params) => {
  return request.post('/portal/contractModify/queryList', params)
}
// 删除续签，变更，终止合同
const deleteContractIds = (params) => {
  return request.post('/portal/contract/deleteContract', params)
}

// 特殊商业合同
const addSpecialContract = (params) => {
  return request.post('/iparkcloud-estate/contract/addSpecialContract', params)
}
const updateSpecialContract = (params) => {
  return request.post('/iparkcloud-estate/contract/updateSpecialContract', params)
}
const archiveSpecialContract = (params) => {
  return request.post('/portal/contract/archiveSpecialContract', params)
}
const setSpecialBills = (params) => {
  return request.post('/iparkcloud-estate/contract/setSpecialBills', params)
}

export default {
  setBillsTurnover,
  showBillsListbyPage2,
  newgetContractList,
  getContractList,
  queryContractPageByConditionSimple,
  checkSerialNumberIsExit,
  getCompanyList,
  addContract,
  updateContract,
  deleteContract,
  showBillsListbyPage,
  showThirdPartyContractBills,
  getContractFile,
  getContractInfo,
  confirmContract,
  getParkContractModel,
  fileQueryInfo,
  delAttachment,
  addAttachment,
  getContractTerms,
  setContractTerms,
  getBillList,
  archiveContract,
  modifyContract,
  setEffectDate,
  setContractEffect,
  renewContract,
  queryHeatingContractPageByCondition,
  setRenewEffectDate,
  getContractVersionList,
  queryLastModifyRecordList,
  getRenancyContractDetail,
  heatingBillCalculation,
  getRenancyContractList,
  addRenancyContract,
  auditContractTerminate,
  showSharingContractBillsByItem,
  getTerminateNumber,
  updateRenancyContract,
  deleteRenancyContract,
  getContractCompanyList,
  getCompanyContractList,
  queryContractBillInfo,
  queryTerminateContractBillByPage,
  renewTerminateContractBill,
  getBillStandardList,
  NewshowThirdPartyContractBills,
  addBillsList,
  updateCompanyCreditCode,
  fetchChangeRecord,
  getChangeRecordDetail,
  delContract,
  exportBillsListbyPage,
  updateContractNumAndData,
  newRenancyContract,
  getCalDiscount,
  getContractRenewList,
  getContractChangeList,
  deleteContractIds,
  updateCount,
  addSpecialContract,
  updateSpecialContract,
  archiveSpecialContract,
  setSpecialBills
}



// WEBPACK FOOTER //
// ./src/area-contract/api/contractService.js